import _export from '../internals/export.js';
import isObject$1 from '../internals/is-object.js';
import '../internals/internal-metadata.js';
import freezing from '../internals/freezing.js';
import fails$1 from '../internals/fails.js';
import { i as internalMetadata } from '../../../../../../_virtual/internal-metadata.js';

var $ = _export;
var isObject = isObject$1;
var onFreeze = internalMetadata.exports.onFreeze;
var FREEZING = freezing;
var fails = fails$1; // eslint-disable-next-line es/no-object-seal -- safe

var $seal = Object.seal;
var FAILS_ON_PRIMITIVES = fails(function () {
  $seal(1);
}); // `Object.seal` method
// https://tc39.es/ecma262/#sec-object.seal

$({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES,
  sham: !FREEZING
}, {
  seal: function seal(it) {
    return $seal && isObject(it) ? $seal(onFreeze(it)) : it;
  }
});
